const setBodyOverflowHidden = (bool: boolean) => {
  document.getElementsByTagName('body')[0].style.overflow = bool
    ? 'hidden'
    : 'initial'
}

export default setBodyOverflowHidden
